import v from "./index.es328.js";
import F from "./index.es299.js";
import D from "./index.es301.js";
function l(e) {
  "@babel/helpers - typeof";
  return l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, l(e);
}
function P(e, r, i) {
  var c = i.getStyle, g = i.getSharedString, p = i.customFont, d = i.dateFormat, b = i.usesSchema, s = r + 1, u, h = e.map(function(n, w) {
    if (n == null)
      return "";
    var m = n.height, y = F(n), t = n.type, o = n.value, a = n.format;
    if (N(o) ? o = null : t === void 0 && (b || (t = C(o)), t === void 0 && (t = String, o = String(o))), a) {
      if (t !== Date && t !== Number && t !== String && t !== "Formula")
        throw new Error('`format` can only be used on `Date`, `Number`, `String` or `"Formula"` cells');
      if (t === String && a !== "@")
        throw new Error('`String` cells only support "@" `format`');
    } else
      t === Date && (a = d);
    var S;
    return (a || p || y) && (S = c(y || {}, {
      format: a
    })), m && (u === void 0 || u < m) && (u = m), v(s, w, o, t, S, g);
  }).join(""), f = {
    r: s
  };
  return u && (f.ht = u, f.customHeight = 1), "<row".concat(D(f), ">") + h + "</row>";
}
function N(e) {
  return e == null || e === "";
}
function C(e) {
  switch (l(e)) {
    case "string":
      return String;
    case "number":
      return Number;
    case "boolean":
      return Boolean;
    default:
      if (e instanceof Date)
        return Date;
  }
}
export {
  P as default
};
//# sourceMappingURL=index.es297.js.map
